import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import StudyCourse from '@/types/table/studyCourse';
import { StudyCategoriesData } from '@/api/generated/studyCategoriesController';
import { StudyResourcesData } from '@/api/generated/studyResourcesController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface StudyCourseData extends StudyCourse {
  studyCategories?: StudyCategoriesData;
  studyResourcesList?: StudyResourcesData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class StudyCourseController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<StudyCourseData>>(
      API_CONTEXT + '/upms/studyCourse/list',
      params,
      httpOptions,
    );
  }
  static myList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<StudyCourseData>>(
      API_CONTEXT + '/upms/studyCourse/myList',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<StudyCourseData>(API_CONTEXT + '/upms/studyCourse/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/studyCourse/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/studyCourse/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/studyCourse/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/studyCourse/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/studyCourse/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/studyCourse/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/studyCourse/deleteBatch', params, httpOptions);
  }
  static listStudyCourseResources(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/studyCourse/listStudyCourseResources',
      params,
      httpOptions,
    );
  }
  static listNotInStudyCourseResources(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/studyCourse/listNotInStudyCourseResources',
      params,
      httpOptions,
    );
  }
  static addStudyCourseResources(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/studyCourse/addStudyCourseResources',
      params,
      httpOptions,
    );
  }
  static deleteStudyCourseResources(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/studyCourse/deleteStudyCourseResources',
      params,
      httpOptions,
    );
  }
  static deleteStudyCourseResourcesList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/studyCourse/deleteStudyCourseResourcesList',
      params,
      httpOptions,
    );
  }
  static updateStudyCourseResources(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/studyCourse/updateStudyCourseResources',
      params,
      httpOptions,
    );
  }
  static viewStudyCourseResources(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(
      API_CONTEXT + '/upms/studyCourse/viewStudyCourseResources',
      params,
      httpOptions,
    );
  }
}
